import { useSprintMutation, useSprintQueryClient, SprintMutationResult } from "sprint-common-web";

import { UpdateOnPremAudioAssetTechnicalRequest } from "../../../../../../common/api/master-api/assets/details/UpdateOnPremAudioAssetTechnicalRequest";
import { UpdateOnPremAudioAssetTechnicalResponse } from "../../../../../../common/api/master-api/assets/details/UpdateOnPremAudioAssetTechnicalResponse";
import { useAssetsApi } from "../../../../../../common/api/master-api/assets/useAssetsApi";
import { OnPremAssetQueryKey } from "../../../common/OnPremAssetQueryKey";

export interface UseEditOnPremAsset {
    updateOnPremAudioAssetTechnical: SprintMutationResult<
        UpdateOnPremAudioAssetTechnicalRequest,
        UpdateOnPremAudioAssetTechnicalResponse
    >;
}

export const useEditOnPremAudioAssetTechnical = ({
    invalidationKey
}: {
    invalidationKey?: string;
}): UseEditOnPremAsset => {
    const assetsApi = useAssetsApi();
    const sprintQueryClient = useSprintQueryClient();

    const updateOnPremAudioAssetTechnical = useSprintMutation<
        UpdateOnPremAudioAssetTechnicalRequest,
        UpdateOnPremAudioAssetTechnicalResponse
    >({
        mutationFn: async ({
            assetId,
            audioFormat,
            duration,
            sampleRate,
            channelsCount,
            audioBitRate
        }: UpdateOnPremAudioAssetTechnicalRequest) => {
            if (!assetId) {
                throw new Error("Asset ID is required to update Audio asset technical details.");
            }

            return assetsApi.updateOnPremAudioAssetTechnical({
                assetId,
                audioFormat,
                duration,
                sampleRate,
                channelsCount,
                audioBitRate
            });
        },
        onSettled: async () => {
            await sprintQueryClient.invalidateQueries({
                queryKey: [OnPremAssetQueryKey.OnPremAssetDetails, invalidationKey]
            });
        }
    });

    return {
        updateOnPremAudioAssetTechnical
    };
};
